import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import React from "react";

const BrandLogo = ({
  mode,
  toggleCollapse,
  onClickLogo,
  isCollapsed,
}) => (
  <div
    className={"flex flex-row justify-between items-center mb-2 cursor-pointer"}
    onClick={() => {
      if (mode === 'desktop') {
        toggleCollapse();
      } else {
        onClickLogo()
      }
    }}
  >
    {mode === 'desktop'
      ? !isCollapsed
        ? (
          <img src={"/img/logo.png"} alt="logo" className="w-full" />
        )
        : null
      : (
        <div className="flex flex-col flex-1 flex-end">
          <FontAwesomeIcon icon={faArrowLeft} className="text-lg self-end mb-2"/>
        </div>
      )
    }
  </div>
)

export default BrandLogo;